/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import classNames from 'classnames';
import { TicketPreviewList } from './ticket_preview_list.jsx';

export const BuyTicketsButton = function(props) {
  const free_class = props.free ? props.register_class : props.buy_tickets_class;
  const base_classes = props.className ? props.className : 'btn btn-color-alt btn-large fullwidth em-link';
  const classes = classNames(base_classes, free_class);

  const button_label = props.loading ?
    'Checking'
  : props.free ?
    props.register_label
  :
    props.buy_tickets_label;

  return <div>
    {props.error && <p className="error_marker">There was an error processing your request. Please try again</p>}

    <div className="user_action">
      <a href="#"
         ref={props.buttonRef}
         onClick={props.onClick}
         className={classes}
         aria-label={`${button_label  } for ${  props.event_name}`}
         data-ga-event="true" data-ga-category="Event" data-ga-label={props.event_name}
         data-ga-action={button_label}>

        {button_label}
        <i className="fas fa-long-arrow-alt-right"></i>
      </a>
    </div>
  </div>;
};
